module.exports = __webpack_public_path__ + "static/img/tl_2@2x.90e2565b.png";